import React, { Component } from 'react';
import './FooterStyle.css';

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="container flex-container"
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '100%',
            color: '#CDCDCD'
          }}
        >
          <a style={{
            color: '#CDCDCD',
            textDecoration: 'none'
          }} href="https://www.eaterpad.com/policy.html">Terms and Conditions &amp; Privacy Policy</a>
        </div>
      </footer>
    );
  }
}


export default Footer;
